import React, { useEffect, useState } from "react";
import "../pages/styles/AppSplash.css";
import kuptoSplash from "../images/logo/splash_logo.png";

export default function AppSplash() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`app-splash ${visible ? "app-splash--visible" : ""}`}>
      <img
        src={kuptoSplash}
        alt="Kupto"
        className="app-splash__image"
      />
    </div>
  );
}